<template>
  <div>
    <div v-if="hasDevice">
      <el-row>
        <div class="title">暂无设备</div>
      </el-row>
    </div>
    <div v-for="(itemTag,index) in deviceTagList" :key="index">
      <el-row v-if="deviceInfoList[itemTag]  !== null && deviceInfoList[itemTag].length > 0">
        <div class="title">{{ itemTag }}设备</div>
      </el-row>
      <el-row v-if="deviceInfoList[itemTag]  !== null && deviceInfoList[itemTag].length > 0">
        <ul>
          <li :key="index" @touchstart="showDetail(item.id)" @click="showDetail(item.id)" v-for="(item,index) in deviceInfoList[itemTag]">
            <device-show-comp
                :device-show-brand="deviceShowBrand" :device-show-model="deviceShowModel"
                :device-info="item"
                class="m-2 pointer"/>
          </li>
        </ul>
      </el-row>
    </div>

    <!--设备详情-->
    <device-detail :distribution-style="false" ref="deviceDetail"></device-detail>
  </div>
</template>

<script>
import DeviceShowComp from "@/views/basic_operations/monitoring/device_list/comp/DeviceShowComp";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";
import {getSystematicByCodes} from "@/network/systematic";

export default {
  name: "DeviceTagComp",
  components: {DeviceShowComp, DeviceDetail},
  data() {
    return {
      deviceShowBrand: true,
      deviceShowModel: true
    }
  },
  props: {
    hasDevice: {},
    deviceInfoList: {},
    deviceTagList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    getSystematicByCodes(['dcim_device_show_brand', 'dcim_device_show_model']).then(res => {
      if (res.code === 0) {
        res.data.forEach(item => {
          if (item.code === 'dcim_device_show_brand') {
            this.deviceShowBrand = item.val1 === 'true'
          } else if (item.code === 'dcim_device_show_model') {
            this.deviceShowModel = item.val1 === 'true'
          }
        })
      }
    })
  },
  methods: {
    showDetail(deviceId) {
      this.$refs.deviceDetail.showDeviceDetails(deviceId);
    }
  }
}
</script>

<style scoped>
.title {
  height: 20px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 20px;
  color: #07E6F8;
  opacity: 1;
  text-align: left;
}

ul, ul li {
  list-style: none;
  float: left;
  padding: 0;
}
</style>
